import { Parcel } from '../../../models/Parcel/Parcel.js';

class Parcels {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  set(parcel) {
    return this.apiClient.post('/v1/users/parcels', parcel.getCreatePayload()).then(response => Parcel.createFromResponse(response.data));
  }
  update(parcel) {
    return this.apiClient.put(`/v1/users/parcels/${parcel.id}`, parcel.getUpdatePayload()).then(response => response.data);
  }
  delete(_ref) {
    let {
      id
    } = _ref;
    return this.apiClient.delete(`/v1/users/parcels/${id}`).then(response => response.data);
  }
}

export { Parcels };
//# sourceMappingURL=Parcels.js.map
